export const TLD = {
  CN: 'cn',
  JP: 'jp',
}
